import { useEffect, useMemo, useState } from "react";
import { isStoragePath, resolveAssetUrls } from "@/lib/mediaStorage";

/**
 * Resolves a set of media values (external URLs or Backend Storage paths) into a
 * lookup of storage path -> short-lived signed URL, so <img> tags can render
 * assets that live in private/authenticated storage.
 */
export function useAssetUrlMap(
  values: Array<string | null | undefined>,
): Record<string, string> {
  const [map, setMap] = useState<Record<string, string>>({});

  const key = useMemo(() => {
    const paths = Array.from(new Set(values.filter((value): value is string => isStoragePath(value))));
    return paths.sort().join("|");
  }, [values]);

  useEffect(() => {
    let active = true;
    if (!key) {
      setMap({});
      return () => {
        active = false;
      };
    }
    resolveAssetUrls(key.split("|")).then((result) => {
      if (active) setMap(result);
    });
    return () => {
      active = false;
    };
  }, [key]);

  return map;
}